export const LostStatuses = {
    Deleted: 0,
    Open: 1,
    Pending: 2,
    Review: 3,
    InProcess: 4,
    LFNotified: 5,
    Urgent: 6,
    DraftIncomplete: 7,
    DraftCompleted: 8,
    NotPaid: 9,
    Overdue: 11,
};

export enum PendingRequestOperation {
    Update = "1",
    Delete = "2",
    UpdateShippingInfo = "4",
}

export enum PendingRequestAction {
    Pending = "0",
    Approved = "1",
    Rejected = "2"
}
